import PropTypes from 'prop-types';
import { useState } from 'react';
import { TextField, FormHelperText, Switch, FormControlLabel, Divider } from '@mui/material';
import dayjs from 'dayjs';
import CustomAccordions from '../../../../../../../components/Filtering/CustomAccordion';
import MuiTimePicker from '../../../../../../../components/FormFields/MuiTimePicker';
import { EVENT_TYPES } from '../../../../../../../hooks/event-hooks/useEventStatus';
import { H5, Body3, Body1 } from '../../../../../../../themes/typography';

export default function TicketAdvancedSetting({
    isEditModeOn,
    formik,
    eventData,
    onCheckInTimeSelection
}) {
    const charactersLimit = 120;
    const [descCounter, setDescCounter] = useState(0);
    const [attendeeCounter, setAttendeeCounter] = useState(0);

    function handleDescChangeAndCounter(e) {
        const { value } = e.target;
        if (value.length <= charactersLimit) {
            setDescCounter(value.length);
            formik.setFieldValue('description', value);
        } else {
            formik.setFieldValue('description', value.substring(0, charactersLimit));
            setDescCounter(charactersLimit);
        }
    }

    function handleAttendeeMessageChangeAndCounter(e) {
        const { value } = e.target;
        if (value.length <= charactersLimit) {
            setAttendeeCounter(value.length);
            formik.setFieldValue('messageToAttendees', value);
        } else {
            formik.setFieldValue('messageToAttendees', value.substring(0, charactersLimit));
            setDescCounter(charactersLimit);
        }
    }


    const dateCheckInTime = formik.values.checkInTimes?.length > 0
        ? formik.values.checkInTimes.filter(item => item.type === 'date')
        : [];
    const slotCheckInTime = formik.values.checkInTimes?.length > 0
        ? formik.values.checkInTimes.filter(item => item.type === 'slot')
        : [];

    return (
        <div className="ticket-advanced-setting-container">
            <div className="ticket-desc">
                <TextField
                    fullWidth
                    required
                    id="description"
                    name="description"
                    label="Ticket description"
                    placeholder="Enter ticket description"
                    disabled={!isEditModeOn}
                    value={formik.values.description}
                    onChange={handleDescChangeAndCounter}
                    error={formik.touched.description && Boolean(formik.errors.description)}
                    helperText={formik.touched.description && formik.errors.description}
                />
                <div className="counter-characters">
                    <FormHelperText>{`${descCounter} / ${charactersLimit}`}</FormHelperText>
                </div>
            </div>
            <CustomAccordions
                accordtionTitle="Advance Settings"
                darkMode={true}
                expanded={true}
            >
                <div
                    className="ticket-advanced-setting-container"
                    style={{ paddingBottom: '1.5rem' }}
                >
                    <div className="max-booking-input">
                        <TextField
                            id="maxBookingPerTicket"
                            name="maxBookingPerTicket"
                            label="Maximum Tickets Per Booking"
                            value={formik.values.maxTicketsPerBooking}
                            inputMode="numeric"
                            type="text"
                            disabled={!isEditModeOn}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, '');
                                formik.setFieldValue('maxTicketsPerBooking', value);
                            }}
                            error={
                                formik.touched.maxTicketsPerBooking &&
                                Boolean(formik.errors.maxTicketsPerBooking)
                            }
                            helperText={
                                formik.touched.maxTicketsPerBooking &&
                                formik.errors.maxTicketsPerBooking
                            }
                        />
                    </div>
                    <div className="group-booking-container">
                        <div className="group-booking-input-container">
                            <div className="group-booking-input">
                                <H5 fontWeight={500}>Group Booking?</H5>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            color="main"
                                            id="isGroupTicket"
                                            checked={formik.values.isGroupTicket}
                                            disabled={!isEditModeOn}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'isGroupTicket',
                                                    e.target.checked
                                                )
                                            }
                                        />
                                    }
                                    label={formik.values.isGroupTicket ? 'Yes' : 'No'}
                                />
                            </div>
                            <div className="max-booking-input">
                                {formik.values.isGroupTicket && (
                                    <TextField
                                        id="attendeesPerGroupTicket"
                                        name="attendeesPerGroupTicket"
                                        label="Attendees per ticket"
                                        disabled={!isEditModeOn}
                                        value={formik.values.attendeesPerGroupTicket}
                                        onChange={(e) =>
                                            formik.setFieldValue(
                                                'attendeesPerGroupTicket',
                                                e.target.value
                                            )
                                        }
                                        error={
                                            formik.touched.attendeesPerGroupTicket &&
                                            Boolean(formik.errors.attendeesPerGroupTicket)
                                        }
                                        helperText={
                                            formik.touched.attendeesPerGroupTicket &&
                                            formik.errors.attendeesPerGroupTicket
                                        }
                                    />
                                )}
                            </div>
                        </div>
                        <div className="group-booking-notes">
                            {formik.values.isGroupTicket && (
                                <Body3>
                                    This ticket allows multiple attendees on purchase of a
                                    single ticket.
                                </Body3>
                            )}
                            {!formik.values.isGroupTicket && (
                                <Body3>
                                    This ticket allows only one attendee on purchase of a single
                                    ticket.
                                </Body3>
                            )}
                        </div>
                    </div>
                    <div className="ticket-desc">
                        <TextField
                            fullWidth
                            id="messageToAttendees"
                            name="messageToAttendees"
                            label="Message to attendees"
                            placeholder="Enter message to attendees"
                            value={formik.values.messageToAttendees}
                            // disabled={!isEditModeOn}
                            onChange={handleAttendeeMessageChangeAndCounter}
                        // error={formik.touched.messageToAttendees && Boolean(formik.errors.messageToAttendees)}
                        // helperText={formik.touched.messageToAttendees && formik.errors.messageToAttendees}
                        />
                        <div className="counter-characters">
                            <FormHelperText>
                                {`${attendeeCounter} / ${charactersLimit}`}
                            </FormHelperText>
                        </div>
                    </div>


                    {(slotCheckInTime?.length > 0 || dateCheckInTime?.length > 0) && (
                        <div className='event-ticket-check-in-time-selection'>
                            <H5 fontWeight={500}>Check-in Time Selection</H5>

                            <div className='ticket-check-in-time-date-container'>

                                {/* For Dates */}
                                {dateCheckInTime.length > 0 && slotCheckInTime.length === 0 && eventData?.event_type !== EVENT_TYPES.continuous && dateCheckInTime?.map((item, index) => (
                                    <>
                                        <div key={index + 1} className='each-date-check-in-time-container'>
                                            <div className='each-date-check-in-index'>
                                                <Body1 fontWeight={350}>
                                                    {index + 1}.
                                                </Body1>
                                            </div>

                                            <div className='each-date-check-in-details'>

                                                <div className='each-date-check-in-date'>
                                                    <Body1 fontWeight={400}>
                                                        {item.date}
                                                    </Body1>
                                                </div>
                                                <div className='each-date-check-in-date-starttime-endtime'>
                                                    <Body1 fontWeight={350}>
                                                        {item.from_time} to {item.to_time}
                                                    </Body1>
                                                </div>
                                                <div className='each-date-check-in-input'>
                                                    <MuiTimePicker
                                                        label="Select Check-in Time"
                                                        id={`selectCheckInTime-${index + 1}`}
                                                        value={dayjs(item?.checkInTime, 'HH:mm')}
                                                        maxTime={dayjs(item?.from_time, 'HH:mm')}
                                                        onChange={(newVal) => onCheckInTimeSelection && onCheckInTimeSelection(item.id, newVal)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {index !== dateCheckInTime.length - 1 && (
                                            <Divider
                                                sx={{
                                                    borderColor: 'var(--divider-color)',
                                                    alignSelf: 'stretch'
                                                }}
                                            />
                                        )}
                                    </>
                                ))}

                                {dateCheckInTime.length > 0 && slotCheckInTime.length === 0 && eventData?.event_type === EVENT_TYPES.continuous && (
                                    <>
                                        <div className='each-date-check-in-time-container'>

                                            <div className='each-date-check-in-details'>

                                                <div className='each-date-check-in-date'>
                                                    <Body1 fontWeight={400}>
                                                        {dateCheckInTime[0]?.date} to {dateCheckInTime[dateCheckInTime.length - 1]?.date}
                                                    </Body1>
                                                </div>
                                                <div className='each-date-check-in-date-starttime-endtime'>
                                                    <Body1 fontWeight={350}>
                                                        {dateCheckInTime[0]?.from_time} to {dateCheckInTime[dateCheckInTime.length - 1]?.to_time}
                                                    </Body1>
                                                </div>
                                                <div className='each-date-check-in-input'>
                                                    <MuiTimePicker
                                                        label="Select Check-in Time"
                                                        id={`selectCheckInTime`}
                                                        value={dayjs(dateCheckInTime[0]?.checkInTime, 'HH:mm')}
                                                        onChange={(newVal) => onCheckInTimeSelection && onCheckInTimeSelection(dateCheckInTime[0]?.id, newVal)}
                                                        maxTime={dayjs(dateCheckInTime[0]?.from_time, 'HH:mm')}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}


                                {/* For Slots */}
                                <div className='ticket-check-in-time-inputs-container-slot'>
                                    {slotCheckInTime.length > 0 && (
                                        <div className='ticket-check-in-time-label'>
                                            <Body1
                                                fontWeight={400}
                                                color="var(--secondary-color)"
                                            >
                                                {dateCheckInTime[0]?.date}
                                            </Body1>
                                        </div>
                                    )}

                                    <div className='ticket-check-in-slot-listing'>

                                        {slotCheckInTime?.map((item, index) => (
                                            <>
                                                <div className='each-date-check-in-time-container' key={index + 1}>
                                                    <div className='each-date-check-in-index'>
                                                        <Body1 fontWeight={350}>
                                                            {index + 1}.
                                                        </Body1>
                                                    </div>

                                                    <div className='each-date-check-in-details'>

                                                        <div className='each-date-check-in-index'>
                                                            <Body1 fontWeight={350}>
                                                                Slot {index + 1}
                                                            </Body1>
                                                        </div>
                                                        <div className='each-date-check-in-date-starttime-endtime'>
                                                            <Body1 fontWeight={350}>
                                                                {item?.from_time} to {item?.to_time}
                                                            </Body1>
                                                        </div>
                                                        <div className='each-date-check-in-input'>
                                                            <MuiTimePicker
                                                                label="Select Check-in Time"
                                                                id={`selectCheckInTime-${index}`}
                                                                value={dayjs(item?.checkInTime, 'HH:mm')}
                                                                onChange={(newVal) => onCheckInTimeSelection && onCheckInTimeSelection(item.id, newVal)}
                                                                maxTime={dayjs(dateCheckInTime[0]?.from_time, 'HH:mm')}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {index !== slotCheckInTime?.length - 1 && (
                                                    <Divider
                                                        sx={{
                                                            borderColor: 'var(--divider-color)',
                                                            alignSelf: 'stretch'
                                                        }}
                                                    />
                                                )}
                                            </>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    )}

                </div>
            </CustomAccordions>
        </div>
    );
}

function CheckInTimeSelection() {
    return (
        <div className='event-ticket-check-in-time-selection'>
            <H5 fontWeight={500}>Check-in Time Selection</H5>

            <div className='ticket-check-in-time-date-container'>

                {demoData?.map((item, index) => (
                    <>
                        <div key={item.id} className='each-date-check-in-time-container'>
                            <div className='each-date-check-in-index'>
                                <Body1 fontWeight={350}>
                                    {index + 1}.
                                </Body1>
                            </div>

                            <div className='each-date-check-in-details'>

                                <div className='each-date-check-in-date'>
                                    <Body1 fontWeight={400}>
                                        {item.date}
                                    </Body1>
                                </div>
                                <div className='each-date-check-in-date-starttime-endtime'>
                                    <Body1 fontWeight={350}>
                                        {item.startTime} to {item.endTime}
                                    </Body1>
                                </div>
                                <div className='each-date-check-in-input'>
                                    <MuiTimePicker
                                        label="Select Check-in Time"
                                        id={`selectCheckInTime-${item.id}`}
                                    />
                                </div>
                            </div>
                        </div>
                        {index !== demoData.length - 1 && (
                            <Divider
                                sx={{
                                    borderColor: 'var(--divider-color)',
                                    alignSelf: 'stretch'
                                }}
                            />
                        )}
                    </>
                ))}


                {demoDataWithSlots?.map((item) => (
                    <div key={item.id} className='ticket-check-in-time-inputs-container-slot'>
                        <div className='ticket-check-in-time-label'>
                            <Body1
                                fontWeight={400}
                                color="var(--secondary-color)"
                            >
                                {item.date}
                            </Body1>
                        </div>
                        <div className='ticket-check-in-slot-listing'>

                            {item.slots.map((slot, slotIndex) => (
                                <>
                                    <div key={slotIndex.id} className='each-date-check-in-time-container'>
                                        <div className='each-date-check-in-index'>
                                            <Body1 fontWeight={350}>
                                                {slotIndex + 1}.
                                            </Body1>
                                        </div>

                                        <div className='each-date-check-in-details'>

                                            <div className='each-date-check-in-index'>
                                                <Body1 fontWeight={350}>
                                                    Slot {slotIndex + 1}
                                                </Body1>
                                            </div>
                                            <div className='each-date-check-in-date-starttime-endtime'>
                                                <Body1
                                                    fontWeight={350}
                                                >
                                                    {slot}
                                                </Body1>
                                            </div>
                                            <div className='each-date-check-in-input'>
                                                <MuiTimePicker
                                                    label="Select Check-in Time"
                                                    id={`selectCheckInTime-${slotIndex.id}`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {slotIndex !== item.slots.length - 1 && (
                                        <Divider
                                            sx={{
                                                borderColor: 'var(--divider-color)',
                                                alignSelf: 'stretch'
                                            }}
                                        />
                                    )}
                                </>
                            ))}

                        </div>
                    </div>
                ))}

            </div>
        </div>
    )
}

TicketAdvancedSetting.propTypes = {
    isEditModeOn: PropTypes.bool.isRequired,
    formik: PropTypes.object.isRequired,
};

const demoData = [
    {
        id: 1,
        date: '29/10/2025',
        startTime: '10:00 AM',
        endTime: '12:00 PM'
    },
    {
        id: 2,
        date: '30/10/2025',
        startTime: '01:00 PM',
        endTime: '03:00 PM'
    },
    {
        id: 3,
        date: '31/10/2025',
        startTime: '10:00 AM',
        endTime: '12:00 PM'
    }
]

const demoDataWithSlots = [
    {
        id: 1,
        date: '29/10/2025',
        startTime: '10:00 AM',
        endTime: '12:00 PM',
        slots: ['10:00 AM to 12:00 PM', '01:00 PM to 03:00 PM']
    }
]